module.exports = __webpack_public_path__ + "img/img (49).f1871f7f.png";